/**
 * Created by swandelow on 06/11/17.
 */
angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:oid/availability", {
        templateUrl: 'templates/availability/availability.html',
        controller: 'AvailabilityController',
        title: 'availability.TITLE',
        sidebar: "priceAndAvailability"
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/availability/availability.route.js
// module id = 930
// module chunks = 3